import { Route } from 'react-router-dom';
import { FeatureRoute } from '../components/auth/FeatureRoute.js';
import { CorrectionsPage, MyAttendancePage, MySitePage } from '../lazyPages.js';

/* ===========================================================================
 * PERSONAL ROUTES — a person's own screens, ungated by role on purpose (see
 * the note above `{PERSONAL_ROUTES}` in App.tsx). A fragment for the reason
 * `approvalDoorRoutes.tsx` gives: App.tsx is size debt behind a ratchet that
 * only lets it shrink. Splice it in as `{PERSONAL_ROUTES}`; it is listed in
 * `test/appRouteSource.ts` so the route-gate suites still read it.
 * ======================================================================== */
export const PERSONAL_ROUTES = (
  <>
    <Route
      path="my-attendance"
      element={
        <FeatureRoute feature="selfService">
          <MyAttendancePage />
        </FeatureRoute>
      }
    />
    <Route
      path="corrections"
      element={
        <FeatureRoute feature="corrections">
          <CorrectionsPage />
        </FeatureRoute>
      }
    />
    {/* A PROJECT MANAGER'S OWN SITE. No role gate: who runs a site is a fact
        about the person, not their role class — an EMPLOYEE can run one. The
        server is the gate (`/worksites/managed` names only the caller's own
        sites, and the live list and roster refuse anybody else), and the page
        says "not a project manager of this site" rather than drawing it. */}
    <Route path="my-sites/:id" element={<MySitePage />} />
  </>
);
